const bcGallery = document.querySelectorAll('.swiper');

bcGallery.forEach((el, i) => {
  const swiper = new Swiper(el, {
    centeredSlides: true,
    autoplay: {
      enabled: true,
    },
    loop: true,
    speed: 700,
    spaceBetween: 0,
    slidesPerView: 1.7,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
      },
      1280: {
        slidesPerView: 5.7,
      },
    },
  });
});

const fadeInElems = document.querySelectorAll('.js-fadeIn');
const fadeInElemsOptions = {
  rootMargin: '0px',
  threshold: 0.2,
};

const fadeIn = (target) => {
  target.classList.add('--visible');
};

const observeFadeInElems = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      fadeIn(entry.target);
    }
  });
};

const floatNav = document.querySelector('.dt-touringcamp-float');
const navPos = document.querySelector('.dt-touringcamp-nav');
const navEnd = document.querySelector('.dt-touringcamp');
console.log(navPos);
const navPosRect = navPos.getBoundingClientRect();
const navPosTop = navPosRect.top + document.body.scrollTop;
const navEndRect = navEnd.getBoundingClientRect();
const navEndBottom = navEndRect.bottom + document.body.scrollTop;

let lastKnownScrollPosition = 0;
let ticking = false;

function showFloat(scrollPos) {
  if (scrollPos > navPosTop && scrollPos < navEndBottom) {
    floatNav.classList.add('--visible');
  } else {
    floatNav.classList.remove('--visible');
  }
}

document.addEventListener('scroll', (event) => {
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(() => {
      showFloat(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});

const fadeInObserver = new IntersectionObserver(observeFadeInElems, fadeInElemsOptions);
fadeInElems.forEach(iSObserver => {
  fadeInObserver.observe(iSObserver);
});

const headerHeight = document.getElementById('shopify-section-header').offsetHeight;
const floatNavList = document.querySelector('.dt-touringcamp-float__nav');
const floatNavLink = document.querySelectorAll('.dt-touringcamp-float__nav li');
const section = document.querySelectorAll('.js-section');
const sectionOptions = {
  rootMargin: '-' + headerHeight + 'px 0px 0px 0px',
  threshold: 0,
};

const removeCurrent = () => {
  floatNavLink.forEach((el, i) => {
    el.classList.remove('--current');
  });
};

const observeSectionElems = (entries) => {
  entries.forEach(entry => {
    const sectionID = entry.target.id;
    const linkTarget = document.querySelector('[data-sec="' + sectionID + '"]');
    if (entry.intersectionRatio > 0) {
      floatNavLink.forEach((el, i) => {
        const thisEl = el.getAttribute('data-sec');
        if (sectionID != thisEl) {
          el.classList.remove('--current');
        }
      });
      linkTarget.classList.add('--current');
      const childPosition = linkTarget.getBoundingClientRect();
      const parentPosition = linkTarget.parentElement.getBoundingClientRect();
      const scrollDistance = childPosition.left - parentPosition.left;
      linkTarget.parentElement.scrollLeft += scrollDistance;
    } else {
      linkTarget.classList.remove('--current');
    }
  });
};

const sectionObserver = new IntersectionObserver(observeSectionElems, sectionOptions);
section.forEach(iSObserver => {
  sectionObserver.observe(iSObserver);
});

